import { Notifier } from "@opendaw/lib-std";
const WINDOW_SECONDS = 5;
export class TrafficMeter {
    #uploadBuckets = new Int32Array(WINDOW_SECONDS);
    #downloadBuckets = new Int32Array(WINDOW_SECONDS);
    #notifier = new Notifier();
    #cursor = 0;
    #timer;
    constructor() {
        this.#timer = setInterval(() => this.#tick(), 1000);
    }
    recordUpload(bytes) { this.#uploadBuckets[this.#cursor] += bytes; }
    recordDownload(bytes) { this.#downloadBuckets[this.#cursor] += bytes; }
    get uploadRate() { return this.#sumBuckets(this.#uploadBuckets) / WINDOW_SECONDS; }
    get downloadRate() { return this.#sumBuckets(this.#downloadBuckets) / WINDOW_SECONDS; }
    subscribe(observer) { return this.#notifier.subscribe(observer); }
    terminate() { clearInterval(this.#timer); }
    #tick() {
        const hadTraffic = this.uploadRate > 0 || this.downloadRate > 0;
        this.#cursor = (this.#cursor + 1) % WINDOW_SECONDS;
        this.#uploadBuckets[this.#cursor] = 0;
        this.#downloadBuckets[this.#cursor] = 0;
        if (hadTraffic || this.uploadRate > 0 || this.downloadRate > 0) {
            this.#notifier.notify(this);
        }
    }
    #sumBuckets(buckets) {
        let sum = 0;
        for (let i = 0; i < WINDOW_SECONDS; i++) {
            if (i !== this.#cursor) {
                sum += buckets[i];
            }
        }
        return sum;
    }
}
